import axios from 'axios'
import { createContext, useContext } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import { format } from 'date-fns'

const dateTransformer = (data) => {
  if (data instanceof Date) {
    return format(data, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
  }

  if (Array.isArray(data)) {
    return data.map(dateTransformer)
  }

  if (typeof data === 'object' && data !== null) {
    return Object.fromEntries(Object.entries(data).map(([key, val]) => [key, dateTransformer(val)]))
  }

  return data
}

const AxiosContext = createContext(null)

export function useAxios() {
  const ctx = useContext(AxiosContext)

  if (!ctx) {
    throw new Error('useAxios must be used within an AxiosProvider')
  }

  return ctx
}

export function AxiosProvider({ children }) {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL_V2,
    transformRequest: [dateTransformer, ...axios.defaults.transformRequest],
  })

  instance.interceptors.request.use(
    async function (config) {
      try {
        const { accessToken } = (await fetchAuthSession()).tokens ?? {}

        config.headers['Authorization'] = `Bearer ${accessToken.toString()}`
      } catch (err) {}

      return config
    },
    function (error) {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      return Promise.reject(error)
    }
  )

  return <AxiosContext.Provider value={{ axios: instance }}>{children}</AxiosContext.Provider>
}
